import { useEffect, useState } from "react";
import { Box, Tabs, Tab, Typography } from "@mui/material";
import ProfileSettings from "./Profile";
import BillingSettings from "./Billing";
import HelpSettings from "./Help";
import { AccountCircle, CreditCard, HelpOutline } from '@mui/icons-material';

const Settings = ({ startTab = 0 }) => {
    const [tab, setTab] = useState(startTab);
    const handleTabChange = (_event: any, newValue: number) => {
        setTab(newValue);
    };

    useEffect(() => {
        setTab(startTab);
    }, [startTab]);

    return (
        <Box
            display='flex'
            flexDirection='column'
            alignItems='left'
            gap={3}
            margin={3}
        >
            <Typography variant="h5">Settings</Typography>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={tab} onChange={handleTabChange}>
                    <Tab
                        icon={<AccountCircle />}
                        label="Profile"
                        id="profile-tab"
                        aria-controls="profile-tabpanel"
                        iconPosition="start"
                    />
                    <Tab
                        icon={<CreditCard />}
                        label="Billing & Usage"
                        id="billing-tab"
                        aria-controls="billing-tabpanel"
                        iconPosition="start"
                    />
                    <Tab
                        icon={<HelpOutline />}
                        label="Help"
                        id="help-tab"
                        aria-controls="help-tabpanel"
                        iconPosition="start"
                    />
                </Tabs>
            </Box>
            <div role="tabpanel" hidden={tab !== 0} id="profile-tabpanel" aria-labelledby="profile-tab">
                {tab === 0 && 
                    <ProfileSettings />
                }
            </div>
            <div role="tabpanel" hidden={tab !== 1} id="billing-tabpanel" aria-labelledby="billing-tab">
                {tab === 1 &&
                    <BillingSettings />
                }
            </div>
            <div role="tabpanel" hidden={tab !== 2} id="help-tabpanel" aria-labelledby="help-tab">
                {tab === 2 &&
                    <HelpSettings />
                }
            </div>
        </Box>
    );
}

export default Settings;
